import { createClient } from '@supabase/supabase-js';

// Supabase configuration with enhanced error handling
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('🔍 Supabase Configuration Check:');
console.log('URL exists:', !!supabaseUrl);
console.log('Key exists:', !!supabaseAnonKey);
console.log('URL value:', supabaseUrl ? `${supabaseUrl.substring(0, 30)}...` : 'Not set');

// Check if Supabase credentials are properly configured
const isSupabaseConfigured = supabaseUrl && supabaseAnonKey && 
  !supabaseUrl.includes('your-project') && 
  !supabaseAnonKey.includes('your-anon-key') &&
  supabaseUrl.includes('supabase.co');

console.log('✅ Supabase configured:', isSupabaseConfigured);

// Initialize Supabase
let supabase;
let firebaseStatus = 'demo'; // Keep same variable name for compatibility

// Create Supabase auth object that mimics Firebase auth interface
const auth = {
  onAuthStateChanged: null,
  signOut: null,
  currentUser: null
};

// Mock googleProvider for compatibility
const googleProvider = {};

// Mock db for compatibility  
const db = {
  collection: null
};

if (isSupabaseConfigured) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
    firebaseStatus = 'configured';
    
    // Set up Supabase auth methods that mimic Firebase
    auth.onAuthStateChanged = (callback) => {
      // Get initial user state
      supabase.auth.getUser().then(({ data: { user } }) => {
        if (user) {
          // Transform Supabase user to Firebase-like user
          const firebaseUser = {
            uid: user.id,
            email: user.email,
            displayName: user.user_metadata?.full_name || user.user_metadata?.name || user.email?.split('@')[0],
            photoURL: user.user_metadata?.avatar_url || user.user_metadata?.picture,
            emailVerified: user.email_confirmed_at ? true : false
          };
          auth.currentUser = firebaseUser;
          callback(firebaseUser);
        } else {
          auth.currentUser = null;
          callback(null);
        }
      });

      // Listen for auth changes
      const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
        if (session?.user) {
          const firebaseUser = {
            uid: session.user.id,
            email: session.user.email,
            displayName: session.user.user_metadata?.full_name || session.user.user_metadata?.name || session.user.email?.split('@')[0],
            photoURL: session.user.user_metadata?.avatar_url || session.user.user_metadata?.picture,
            emailVerified: session.user.email_confirmed_at ? true : false
          };
          auth.currentUser = firebaseUser;
          callback(firebaseUser);
        } else {
          auth.currentUser = null;
          callback(null);
        }
      });

      // Return unsubscribe function
      return () => {
        subscription?.unsubscribe();
      };
    };

    auth.signOut = async () => {
      await supabase.auth.signOut();
      auth.currentUser = null;
    };

    console.log('🔥 Supabase initialized successfully');
    console.log('✅ Google Sign-In available via Supabase Auth');
    console.log('📊 Database: PostgreSQL via Supabase');
  } catch (error) {
    console.error('❌ Supabase initialization failed:', error);
    firebaseStatus = 'error';
    supabase = null;
  }
} else {
  console.warn('⚠️ Supabase not configured - running in demo mode');
  console.log('📝 To enable Supabase:');
  console.log('1. Create a Supabase project at https://supabase.com');
  console.log('2. Enable Authentication with Google provider');
  console.log('3. Add your Supabase URL and anon key to .env file');
  supabase = null;
}

export { supabase, firebaseStatus, auth, googleProvider, db };
export default supabase;